import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { COLORS } from "constants/colors"; // COLORS をインポート

export default function ChiPayPayButton({ onClick, disabled }) {
  return (
    <Button
      variant="contained"
      disabled={disabled}
      sx={{
        width: "100%",
        padding: "8px",
        borderRadius: "27px",
        border: `2px solid ${COLORS.TEXT_BLACK}`,
        height: "54px",
        background: "transparent",
        "&:hover": {
          opacity: 0.9, // ホバー時の軽いエフェクト
        },
      }}
      onClick={onClick}
    >
      {/* url(/paypay_logo.png)を使用する */}
      <img src="/paypay_logo.png" alt="PayPay" style={{ height: 44 }} />
    </Button>
  );
}
